module.exports = __webpack_public_path__ + "static/img/67.5268db7e.jpg";